import React from 'react';
import { useHistory } from 'react-router-dom';

import { useRouteConfiguration } from '../../../context/routeConfigurationContext';
import { pathByRouteName } from '../../../util/routes';
import { NamedLink } from '../../../components';

const isModifiedEvent = event => {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

const shouldHandleClientSideNavigation = (event, target) => {
  if (event.defaultPrevented) {
    return false;
  }

  if (event.button !== 0) {
    return false;
  }

  if (target && target !== '_self') {
    return false;
  }

  return !isModifiedEvent(event);
};

const AuthNavLink = props => {
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();
  const { name, params, to, target, onClick, ...rest } = props;

  const handleClick = event => {
    if (typeof onClick === 'function') {
      onClick(event);
    }

    if (!shouldHandleClientSideNavigation(event, target)) {
      return;
    }

    event.preventDefault();

    const pathname = pathByRouteName(name, routeConfiguration, params);
    history.push({
      pathname,
      ...(to || {}),
    });
  };

  return <NamedLink name={name} params={params} to={to} target={target} onClick={handleClick} {...rest} />;
};

export default AuthNavLink;
